import { DeviceModel } from '@models/device.model';


export const speakerBrandsStr: { [Property in DeviceModel.SpeakerBrands]: string } = {
  [DeviceModel.SpeakerBrands.TOA]: 'TOA',
  [DeviceModel.SpeakerBrands.Uniview]: 'Uniview',
  [DeviceModel.SpeakerBrands.UniviewV2]: 'Uniview V2',
  [DeviceModel.SpeakerBrands.SIP]: 'SIP client',
  [DeviceModel.SpeakerBrands.Hikvision]: 'Hikvision',

};
